import { useQuery } from '@tanstack/react-query';
import { getCapaDashboard } from '@/api/dms/generated/sdk.gen';
import { useAuth } from '@/context/AuthContext';

export function useOpenCapaCount() {
  const { token } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['capas', 'open-count'],
    queryFn: async () => {
      const { data } = await getCapaDashboard({ throwOnError: true });
      const summary = data.summary;
      // Open = investigating + awaiting_external + completed (not yet closed)
      return { count: summary.investigating + summary.awaiting_external + summary.completed };
    },
    enabled: !!token,
    refetchInterval: 60_000,
    retry: false,
  });

  return {
    count: data?.count ?? 0,
    isLoading,
  };
}
